import { render, staticRenderFns } from "./SCCTownshipChoose.vue?vue&type=template&id=27f601d9&scoped=true&"
import script from "./SCCTownshipChoose.vue?vue&type=script&lang=js&"
export * from "./SCCTownshipChoose.vue?vue&type=script&lang=js&"
import style0 from "./SCCTownshipChoose.vue?vue&type=style&index=0&id=27f601d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f601d9",
  null
  
)

export default component.exports